import * as React from 'react'

function SvgIconDropArrowS(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="drop-arrow--s" aria-labelledby="t-drop-arrow--s d-drop-arrow--s">
        <title id="t-drop-arrow--s">{'Drop arrow south'}</title>
        <desc id="d-drop-arrow--s">{'Arrow pointing south'}</desc>
        <path d="M24.004 10H8.002a1.997 1.997 0 00-1.415 3.413l7.999 8a1.993 1.993 0 002.825.001l8.004-8A2 2 0 0024.004 10z" />
      </g>
    </svg>
  )
}

export default SvgIconDropArrowS
